/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceAuditProblemResolutionType {
  CarrierCorrection = "carrier_correction",
  AdditionalChargeIssued = "additional_charge_issued",
  FreightsimpleAbsorbedCost = "freightsimple_absorbed_cost",
  Minor = "minor",
}

export function instanceOfInvoiceAuditProblemResolutionType(
  value: any,
): boolean {
  for (const key in InvoiceAuditProblemResolutionType) {
    if (
      Object.prototype.hasOwnProperty.call(
        InvoiceAuditProblemResolutionType,
        key,
      )
    ) {
      if (
        InvoiceAuditProblemResolutionType[
          key as keyof typeof InvoiceAuditProblemResolutionType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceAuditProblemResolutionTypeFromJSON(
  json: any,
): InvoiceAuditProblemResolutionType {
  return InvoiceAuditProblemResolutionTypeFromJSONTyped(json, false);
}

export function InvoiceAuditProblemResolutionTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemResolutionType {
  return json as InvoiceAuditProblemResolutionType;
}

export function InvoiceAuditProblemResolutionTypeToJSON(
  value?: InvoiceAuditProblemResolutionType | null,
): any {
  return value as any;
}

export function InvoiceAuditProblemResolutionTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemResolutionType {
  return value as InvoiceAuditProblemResolutionType;
}
